import { Component, OnInit } from '@angular/core';
import {
    ApiContractDataModel, ApiPaymentHistoryItem,
    ApiPaymentInfo
} from "../../common/model/cchsApiContractData.model";
import {UtilitiesService} from "../../common/service/utilities.service";
import {NotificationsService} from "../../common/service/notifications.service";
import {CinchDataService} from "../../common/service/cinch-data.service";
import {PaymentViewData} from "../../common/model/cinchAppViewData.model";




@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.scss']
})
export class PaymentsComponent implements OnInit {

    dataIsSet = false;
    viewData: PaymentViewData  = {};

  constructor(private util:UtilitiesService,
              private cinchData: CinchDataService,
              private notificationMsg: NotificationsService){}

  ngOnInit() {
      this.cinchData.contractData$.subscribe(contract => {
          if ((contract != {}) && (contract.paymentInfo)){
            this.viewData = this.cinchData.getPaymentsViewOnFormat(contract);
            this.dataIsSet = true;
          }
      }, err => console.error(err));
  }



}
